import styled from '@emotion/styled';

import { PrimaryTableRow as BasePrimaryTableRow } from '@Calix-Commerce/design-system/components';

export const PrimaryTableRow = styled(BasePrimaryTableRow)`
  td {
    padding-top: 0.65rem;
    padding-bottom: 0.65rem;
  }
`;
